/*
  Koji: frecce avanti/indietro per le file scorrevoli "Continua la saga" e "Edizioni speciali".
  Stesso design delle frecce delle sezioni prodotti della home (koji-col-arrow).
  Si applica a ogni .koji-saga-volumes-list presente o aggiunta dopo (le righe vengono ricostruite da koji-saga-rows.js).
*/
(function () {
  'use strict';

  var ICON_PREV = '<svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function makeBtn(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'koji-slider-btn is-' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Scorri indietro' : 'Scorri avanti');
    b.innerHTML = dir === 'prev' ? ICON_PREV : ICON_NEXT;
    b.hidden = true;
    return b;
  }

  function enhance(list) {
    if (!list || list.parentNode.classList.contains('koji-saga-slider')) return;
    var wrap = document.createElement('div');
    wrap.className = 'koji-saga-slider';
    list.parentNode.insertBefore(wrap, list);
    wrap.appendChild(list);
    var prev = makeBtn('prev');
    var next = makeBtn('next');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function update() {
      var max = list.scrollWidth - list.clientWidth;
      if (max <= 4) { prev.hidden = true; next.hidden = true; return; }
      prev.hidden = list.scrollLeft <= 4;
      next.hidden = list.scrollLeft >= max - 4;
    }
    function step(dir) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollBy({ left: dir * Math.max(list.clientWidth * 0.8, 160), behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(list);
    list.addEventListener('load', update, true);
    update();
    setTimeout(update, 400);
  }

  function scan() {
    var lists = document.querySelectorAll('.koji-saga-volumes-list');
    for (var i = 0; i < lists.length; i++) enhance(lists[i]);
  }

  function start() {
    scan();
    var boxes = document.querySelectorAll('.koji-saga-live');
    for (var i = 0; i < boxes.length; i++) {
      new MutationObserver(scan).observe(boxes[i], { childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
